/**
 * Thrown by NotImplementedAdapter and its subclasses when a caller invokes
 * a DeviceContract method against a vendor whose integration has not yet
 * shipped. Distinguishes "vendor known but unbuilt" from generic errors.
 */
export class VendorNotIntegratedError extends Error {
  /** @param {string} vendor  @param {string} method */
  constructor(vendor, method) {
    super(
      `VendorNotIntegratedError: vendor "${vendor}" has no integration for method "${method}". ` +
      `This adapter is a capability-declaration stub. Full integration is scheduled per roadmap.`
    );
    this.name = 'VendorNotIntegratedError';
    this.vendor = vendor;
    this.method = method;
  }
}
